export enum P360Currency {
  USD = 'USD',
  LocalCurrency = 'LocalCurrency',
}
